import { StudioHero } from "@/components/site/StudioProducts";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, BellRing, Brain, Camera, Search } from "lucide-react";
import CompanyLayout, { PhoneMockup } from "@/components/site/CompanyLayout";
import { Seo } from "@/components/site/Seo";
import { FORGOT_SHOTS } from "@/data";

const features = [
  { icon: Brain, title: "Remember anything", body: "Keep appointments, birthdays, places, products and the little things you want to find again." },
  { icon: Camera, title: "Save screenshots", body: "Forgot can understand useful information in a screenshot and make it easier to find later." },
  { icon: Search, title: "Ask Forgot", body: "Ask for the thing you remember saving instead of digging through notes and images." },
  { icon: BellRing, title: "Stay ahead", body: "Bring important events, reservations and plans back to mind at the right time." },
];

const disclosure = "Future shopping partner features are in development and are not part of the current MVP.";

export default function Home() {
  return (
    <CompanyLayout>
      <Seo title="Dream Big Entertainment — Games, Apps & Experiences" description="Discover Colour Cubes and Forgot AI. Dream Big Entertainment creates mobile games, intelligent apps and digital experiences." image="/dream-big-social.png" />
      <main>
        <StudioHero />

        <section id="forgot" className="db-section" data-testid="home-forgot-features">
          <div className="db-container">
            <div className="db-section-heading">
              <div><span className="db-eyebrow">Meet Forgot AI</span><h2 className="db-h2">A second memory<br />for real life.</h2></div>
              <p className="db-body">Forgot remembers the things you don't want to forget and helps you find them when you need them.</p>
            </div>
            <div className="db-feature-grid">
              {features.map((feature) => <article className="db-feature-card" key={feature.title}><span className="db-feature-icon"><feature.icon size={23} strokeWidth={1.8} /></span><h3>{feature.title}</h3><p>{feature.body}</p></article>)}
            </div>
          </div>
        </section>

        <section className="db-editorial db-section">
          <div className="db-container db-editorial-grid">
            <div className="db-editorial-art"><PhoneMockup src={FORGOT_SHOTS.lists} alt="Real Forgot AI Shopping Lists screen" /></div>
            <div className="db-editorial-copy">
              <span className="db-eyebrow">All in one place</span>
              <h2 className="db-h2">Less searching.<br />More living.</h2>
              <p className="db-body">Keep screenshots, plans and discoveries in one place. Add everyday shopping lists too, then return to what you saved without searching through several apps.</p>
              <Link className="db-text-link" to="/forgot-ai">See how Forgot works <ArrowUpRight size={16} /></Link>
            </div>
          </div>
        </section>

        <section id="shopping" className="db-dark-panel db-section" data-testid="home-shopping-coming-soon">
          <div className="db-container db-shopping-grid">
            <div className="db-shopping-copy">
              <span className="db-eyebrow">Useful every day</span>
              <h2 className="db-h2">A simple list.<br />A lighter day.</h2>
              <p className="db-body">Create a shopping list, tick items off and share it with family. More advanced shopping discovery and price tools remain in development.</p>
              <span className="db-pill">IN THE WORKING MVP</span>
              <div><Link className="db-button db-button-light" to="/forgot-ai#shopping">See what's next <ArrowUpRight size={17} /></Link></div>
              <p className="db-disclosure">{disclosure}</p>
            </div>
            <div className="db-shopping-art"><PhoneMockup src={FORGOT_SHOTS.lists} alt="Real Forgot AI Shopping Lists screen" /></div>
          </div>
        </section>

        <section className="db-about-strip" data-testid="home-about-dream-big">
          <div className="db-container db-about-grid">
            <div><span className="db-eyebrow">The company</span><h2 className="db-h2">Small details.<br />Big difference.</h2></div>
            <div><p className="db-body">Dream Big Entertainment is an independent, founder-led company based in London. Alongside Colour Cubes, Forgot AI is our working pre-launch MVP, developed around a simple belief: useful technology should make more room for everyday life.</p><Link className="db-text-link" to="/about">More about Dream Big <ArrowUpRight size={16} /></Link></div>
          </div>
        </section>

        <aside className="db-previous" aria-label="Previous project">
          <div className="db-container db-previous-inner"><span><strong>Previous project</strong> · FOUND, a music discovery concept from Dream Big Entertainment.</span><span>Explore our games and apps.</span></div>
        </aside>
      </main>
    </CompanyLayout>
  );
}
